import { savedOrderListHeaderStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader";

Object.assign(savedOrderListHeaderStyles, {
    toggleFilterGridItem: {
        width: 1,
        style: {
            justifyContent: "flex-end",
            alignSelf: "flex-start",
        },
    },
});
